import useSession from '#/common/hooks/useSession';
import useToast from '#/common/hooks/useToast';
import syncTisTenantDataMutation from '../../tenants/hooks/useSyncTisTenantDataMutation';
import { useCallback, useMemo } from 'react';
import { PageAction } from '#/app/providers/PageProvider';
import { PageActions } from '#/common/components/SubPage';

export default function DataImport() {
  const { alert, confirm } = useToast();
  const { syncTisTenant } = syncTisTenantDataMutation();
  const session = useSession();

  const fetchTisData = useCallback(async () => {
    const sure = await confirm(
      'warning',
      `Are you sure you want fetch the TIS data for ${session.tenantIDs?.length} tenants?`,
    );

    if (!sure) {
      return;
    }

    try {
      const tisIds =
        session.tenants?.map((t) => t.tenant.tisId).filter((tid): tid is string => !!tid) ?? [];

      const result = await syncTisTenant(tisIds);
      if (result?.errors) {
        throw result.errors;
      }

      void alert(
        'success',
        `Buildings, Assets and Asset properties synced! Findings and Alerts are scheduled for sync and will be done in few minutes.`,
      );
    } catch (e: any) {
      console.log('TIS Sync error', e);
      void alert('error', 'Opps, something unexpected happened!');
    }
  }, [confirm, alert, syncTisTenant]);

  const actions = useMemo<PageAction[]>(() => {
    return [
      {
        id: 'fetch-tis-assets',
        type: 'button',
        props: {
          label: 'Sync TIS data',
          onClick: fetchTisData,
        },
      },
      {
        id: 'asset-file-import',
        type: 'button',
        props: {
          label: 'New Data Asset Import',
          path: '/admin/data-import/new',
        },
      },
    ];
  }, [fetchTisData]);

  return (
    <>
      <PageActions actions={actions} />
      <div className="coming-soon">Data Import Table coming soon.</div>
    </>
  );
}
